module.exports = __webpack_public_path__ + "static/media/error.07d9c2b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/Images/error.svg
// module id = 493
// module chunks = 0